const StrDirectory = () => {
  return (
    <div>
      <p>Annuaire sous-traitant page</p>
    </div>
  );
};

export default StrDirectory;
